import { jsx as n, jsxs as i } from "react/jsx-runtime";
import { twMerge as l } from "tailwind-merge";
const x = ({
  description: e,
  descriptionClassName: a,
  error: t,
  errorClassName: r,
  className: s
}) => {
  const m = t ? /* @__PURE__ */ n(
    "p",
    {
      className: l("text-danger [&>a]:text-brand-primary text-sm", r),
      ...typeof t == "string" ? {
        dangerouslySetInnerHTML: { __html: t }
      } : {
        children: t
      }
    }
  ) : null;
  return t || e ? /* @__PURE__ */ i("div", { className: s, children: [
    e ? /* @__PURE__ */ n(
      "span",
      {
        className: l("[&>a]:text-brand-primary text-sm opacity-70", a),
        children: e
      }
    ) : null,
    m
  ] }) : null;
};
export {
  x as FieldErrorAndDescription
};
